export const MODULE_OPTIONS = 'module:options';
//# sourceMappingURL=module.meta.js.map